import React from 'react';
import './SupportPage.css';

function SupportPage() {
    return (
        <div className="App">
            <div className="leftTopBall" />
            <div className="rightTopBall" />
            <div className="leftBottomBall" />
            <div className="rightBottomBall" />
            {/* <div className="centerBall" /> */}
            <div>
                <h1>Flow888 - Support</h1>
                <p>Welcome! If you need help with <strong>Flow888</strong>, you’re in the right place.</p>

                <h2>Contact Us</h2>
                <p>You can reach our support team at:</p>
                <div class="contact">
                    <p>Email: <a href="mailto:winnner62w@gmail.com">winnner62w@gmail.com</a></p>
                </div>
            </div>

        </div>
    );
}

export default SupportPage;
